import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientLegalHeadSaveStateRegistrationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientBaseSaveStateRegistrationParam } from 'api/types/params/onboarding/legalClientSaveStateRegistrationParam';

import { parseLegalClientLegalHeadEntity } from './helpers';

export const useLegalClientLegalHeadSaveStateRegistration = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientLegalHeadSaveStateRegistrationMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientLegalHeadSaveStateRegistration
      ? parseLegalClientLegalHeadEntity(
          data.legalClientLegalHeadSaveStateRegistration
        )
      : undefined,
    loading,
    error,
    saveStateRegistration: useCallback(
      async (
        id: string,
        legalHeadId: string,
        params: LegalClientBaseSaveStateRegistrationParam
      ) => {
        const res = await handle({
          variables: {
            id,
            legalHeadId,
            input: params,
          },
        });
        return res?.data?.legalClientLegalHeadSaveStateRegistration
          ? parseLegalClientLegalHeadEntity(
              res.data.legalClientLegalHeadSaveStateRegistration
            )
          : undefined;
      },
      [handle]
    ),
  };
};
